import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Button from "@mui/material/Button";
import MuiDialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";

import { getScribeModalNestedDialogZIndex } from "features/medical-scribe/medical-scribe-constants";

import type { GenerateError } from "./hooks/use-scribe-generate-actions.hook";

/** Why a summary could not be generated: the subscription's own words on a 402, else a generic line. */
export default function SummaryGenerateErrorDialog({
  error,
  onClose
}: {
  error: GenerateError | null;
  onClose: () => void;
}) {
  const theme = useTheme();
  const isSubscription = error?.kind === "subscription";

  return (
    <MuiDialog
      open={error !== null}
      onClose={onClose}
      sx={{ zIndex: getScribeModalNestedDialogZIndex(theme.zIndex.snackbar) }}
    >
      <DialogTitle>
        {isSubscription ? "Subscription Required" : "Generation Failed"}
      </DialogTitle>
      <DialogContent>
        {error?.kind === "subscription" ? (
          <Alert severity="warning">
            <AlertTitle>{error.error}</AlertTitle>
            {error.message}
          </Alert>
        ) : (
          <Typography>
            Something went wrong while processing your request. Please try again
            in a few moments. If the issue persists, contact Suno support for
            assistance.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </MuiDialog>
  );
}
